import { render, staticRenderFns } from "./GroupPriceUpdate.vue?vue&type=template&id=0af64b98&scoped=true"
import script from "./GroupPriceUpdate.vue?vue&type=script&lang=js"
export * from "./GroupPriceUpdate.vue?vue&type=script&lang=js"
import style0 from "./GroupPriceUpdate.vue?vue&type=style&index=0&id=0af64b98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af64b98",
  null
  
)

export default component.exports